import { BsHouseDoorFill } from "react-icons/bs"
import { BiWifi, BiSun, BiBox } from "react-icons/bi"
import { MdRestaurantMenu } from "react-icons/md"
import { GiSkis } from "react-icons/gi"
import { FaSkiing, FaCoins, FaBed, FaToiletPaper, FaCouch, FaCar } from "react-icons/fa"

const infos = [
	{
		title: "Wohnung",
		icon: BsHouseDoorFill,
		text: "4 1/2 Zimmer mit 8 Betten und kleinem Balkon",
	},

	{
		title: "Schlafen",
		icon: FaBed,
		text: "zwei 2-Bettzimmer (Doppel- oder Einzelbetten) und ein Kajütenbettzimmer mit vier Betten",
	},
	{
		title: "Bäder",
		icon: FaToiletPaper,
		text: "2 kleine Badezimmer mit Dusche, Closomat, Waschmaschine und Tumbler",
	},
	{
		title: "Parking",
		icon: FaCar,
		text: "Zur Wohnung gehören 2 Tiefgaragen-Parkplätze - einer davon mit E-Ladestation.",
	},
	{
		title: "Winter",
		icon: FaSkiing,
		text: "Skipiste Gemsstock 3’<br/> Langlaufloipe 3’ <br/>Skipiste Nätschen 10’ <br/>Eisfeld 15’",
	},
	{
		title: "Sommer",
		icon: BiSun,
		text: "Biketouren, Wanderungen und der herrliche Golfplatz laden zum Bewegen ein. ",
	},
	{
		title: "Essen / Küche",
		icon: MdRestaurantMenu,
		text: "Backofen mit integrierter Mikrowelle, Geschirrspüler, Kaffeemaschine und Schneidmaschine",
	},
	{
		title: "Wohnen",
		icon: FaCouch,
		text: "Die flexible Couch mit Sessel ist von drei Liegen bis zur grossen Sitzlounge einfach wandelbar. ",
	},
	{
		title: "Diverses",
		icon: BiBox,
		text: "Bettwäsche, Tücher, div. Spiele, Föhn & Flatscreen - es ist alles da!",
	},
	{ title: "Wifi", icon: BiWifi, text: "ist vorhanden" },
	{
		title: "Raum",
		icon: GiSkis,
		text: "Externer Parterre-Raum für Skis, Schlitten und Velo ist vorhanden.",
	},
	{ title: "Cost", icon: FaCoins, text: "320 Fr pro Nacht plus Endreinigung 180 Fr" },
]

export default infos
